import '../../css/overlay.css';

const TermsOfService = ({ isOpen, onClose }) => {

  if (!isOpen) return null;

  return (
    <div className="overlay-backdrop" onClick={onClose}>
      <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
        <div className="overlay-header">Terms of Service</div>
        <div style={{ height: "50vh" }}>
          <iframe
            src="/termsOfService.pdf"
            title="Terms of Service"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;